export const nodeTypeGroups = {
    checkbox: 'open',
    text: 'description',
    done: 'closed',
    failed: 'open',
    waiting: 'open',
    idea: 'open',
    cancelled: 'closed'
}

export const isNodeTypeClosed = (type) => {
    return nodeTypeGroups[type] === 'closed'
}

export const isNodeTypeOpen = (type) => {
    return nodeTypeGroups[type] === 'open'
}
